import Icon from "components/AppIcon";
import Input from "components/ui/Input";
import { Download } from "lucide-react";

export default function QrFilterToolbar({companyNames = [], selectedCompany , onCompanyChange, searchTerm, onSearch, buttonLoading ,handleDownload }) {
  return (
    <div className="flex flex-col lg:flex-row p-4 lg:p-6 gap-4 my-4 rounded-lg bg-surface border border-border flex-wrap">
      {/* search bar */}
      <div className="w-full lg:flex-1">
        <div className="relative w-full">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Icon name="Search" size={16} color="#9ca3af" />
          </div>
          <Input
            type="text"
            placeholder="Search Qr Code..."
            className="pl-10 w-full"
            value={searchTerm}
            onChange={(e)=> onSearch(e.target.value)}
          />
        </div>
      </div>
      {/* filters */}
      <div className="flex flex-col sm:flex-row flex-wrap sm:items-center gap-3 w-full lg:flex-1 lg:flex-nowrap">
      {/* Company filter DropDowm */}
      <div className="flex-1 min-w-[180px]">
        <select className="ring-offset-background rounded-md w-full h-10" value={selectedCompany} onChange={(e)=> onCompanyChange(e.target.value)} >
          {companyNames.map((companyName)=>(
              <option key={companyName} value={companyName} >{companyName}</option>
            )
          )}
        </select>
      </div>

      {/* Status filter  */}
      {/* <div className="flex-1 min-w-[120px]">
        <select className="ring-offset-background rounded-md w-full h-10">
          <option>Status</option>
        </select>
      </div> */}

      {/* Export button  */}
      <div className="flex-1 min-w-[140px]">
        <button disabled={buttonLoading} onClick={handleDownload} className="inline-flex gap-2 items-center justify-center w-full bg-primary px-4 py-2  text-white rounded-md ">
          <span>
          <Download size={14} />
          </span>
          <span>Export</span>
        </button>
      </div>

      </div>


    </div>

  )
}